import { API_CALL_SUCCESSFULL } from '../../constants/NumberConstants';
import { PreferencesResponse } from '../../../shared/types/preferences';
import api from '../../api';
import config from '../../config/server-config';
import { CGIPreferences } from './types';
import type { ApiResponse } from '@shared/types';
import { saveToDMI } from '../currency/currency.service';

export const getPreferencesCGI = async (): Promise<CGIPreferences | null> => {
  try {
    const response = await api.get<ApiResponse<CGIPreferences>>(config.GetUserPreferenceCGI);
    if (response.status === API_CALL_SUCCESSFULL && response.data.success) {
      return response.data.data;
    }
    return null;
  } catch {
    return null;
  }
};

export const getPreferences = async (): Promise<PreferencesResponse | null> => {
  let cgiResponse: CGIPreferences | null = null;
  try {
    cgiResponse = await getPreferencesCGI();
  } catch {
    cgiResponse = null;
  }

  try {
    const dmiResponse = await api.post<PreferencesResponse>(config.GetPreferences);

    if (dmiResponse.status === API_CALL_SUCCESSFULL) {
      const isOnlyDMICurrencySet =
        dmiResponse.data.CompensationCurrency && (!cgiResponse || !cgiResponse.currency || !cgiResponse.currency.code);
      const isSameCurrencySet =
        cgiResponse && cgiResponse.currency && cgiResponse.currency.code === dmiResponse.data.CompensationCurrency;

      if (isOnlyDMICurrencySet || isSameCurrencySet) {
        return dmiResponse.data;
      } else if (cgiResponse && cgiResponse.currency) {
        await saveToDMI(cgiResponse.currency.code);
        return {
          ...dmiResponse.data,
          CompensationCurrency: cgiResponse.currency.code,
          CompensationCurrencySymbol: cgiResponse.currency.sign,
          CompensationCurrencyDescription: cgiResponse.currency.name,
        };
      } else {
        return dmiResponse.data;
      }
    }
    return null;
  } catch {
    return null;
  }
};
